import { mapPersonType, useFindPersonDetailsSuspense } from '@api';
import { isPersonSettlementsTabEligible, Tabs, useTabs } from '@common';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/persons/$id';
import { PersonTab, tabs } from '../../data';

type ActiveTab = PersonTab['value'];

export const PersonDetailsTabs: React.FC = () => {
  const { t } = useTranslation('personDetails');
  const { id } = Route.useParams();
  const { activeTab, allowedTabs } = useTabs<PersonTab>(tabs);
  const { data: personDetails } = useFindPersonDetailsSuspense(id, {
    query: { select: (data) => mapPersonType(data.data) },
  });

  const visibleTabs = allowedTabs.filter((tab) => {
    if (tab.value !== 'settlements') {
      return true;
    }

    return isPersonSettlementsTabEligible({
      companyLinks: personDetails.companies,
      hasFinanceRead: true,
    });
  });

  return (
    <Tabs<ActiveTab> value={activeTab ?? 'general'}>
      <Tabs.TabsList>
        {visibleTabs.map((tab) => (
          <Tabs.Tab
            to={`/persons/$id/${tab.value}`}
            params={{ id }}
            key={tab.value}
            value={tab.value}
            pb="md"
          >
            {t(`TABS.${tab.labelKey}`)}
          </Tabs.Tab>
        ))}
      </Tabs.TabsList>
    </Tabs>
  );
};
